import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingPromo from "./components/FloatingPromo";
import FloatingAds from "./components/FloatingAds";
import LandingPage from "./pages/LandingPage";
import HomePage from "./pages/HomePage";
import VehicleDetailPage from "./pages/VehicleDetailPage";
import ComparisonPage from "./pages/ComparisonPage";
import AboutPage from "./pages/AboutPage";
import BuyGuidePage from "./pages/BuyGuidePage";
import BookingPage from "./pages/BookingPage";
import PolicyPage from "./pages/PolicyPage";
import TermsPage from "./pages/TermsPage";
import AdminPage from "./pages/AdminPage";
import "./styles/global.css";

// Generate/persist a session ID per browser session
const getSessionId = () => {
  let sid = sessionStorage.getItem("vf_session_id");
  if (!sid) {
    sid = uuidv4();
    sessionStorage.setItem("vf_session_id", sid);
  }
  return sid;
};

// Record visit (dedup handled server-side)
const recordVisit = async () => {
  try {
    await fetch(`${process.env.REACT_APP_API_URL || (window.location.hostname !== "localhost" ? "/api" : "http://localhost:5000/api")}/stats/visit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ sessionId: getSessionId() }),
    });
  } catch {
    // Silently fail – don't affect UX
  }
};

const AppContent = () => {
  const location = useLocation();
  const isLandingPage = location.pathname === "/";
  const isAdminPage = location.pathname.startsWith("/admin");
  const isVehiclePage = location.pathname.startsWith("/vehicle/");

  return (
    <>
      {!isAdminPage && <Header />}
      
      {isLandingPage ? (
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      ) : (
        <main className={isAdminPage ? "" : "main-content"}>
          <Routes>
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/vehicle/:id" element={<VehicleDetailPage />} />
            <Route path="/compare" element={<ComparisonPage />} />
            <Route path="/mua-xe-gia-tot" element={<AboutPage />} />
            <Route path="/huong-dan-mua-xe" element={<BuyGuidePage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/chinh-sach" element={<PolicyPage />} />
            <Route path="/dieu-khoan" element={<TermsPage />} />
          </Routes>
        </main>
      )}

      {!isLandingPage && !isAdminPage && (
        <>
          <Footer />
          <FloatingPromo />
          {!isVehiclePage && <FloatingAds />}
        </>
      )}
    </>
  );
};

function App() {
  useEffect(() => {
    recordVisit();
  }, []);

  return (
    <Router>
      <div className="app">
        <AppContent />
      </div>
    </Router>
  );
}

export default App;
